import MarkdownButton from './components/MarkdownButton';
import MarkdownToolbar from './components/MarkdownToolbar';

export default {
  'markdown/components/MarkdownButton': MarkdownButton,
  'markdown/components/MarkdownToolbar': MarkdownToolbar,
};
